import React, { memo } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useTranslation } from 'react-i18next'
import './style.css'
import { NoDataProps } from './types'
import { Block } from '../crRender'

const NoData: React.FC<NoDataProps> = ({
  message = 'no-data-available',
  description = '',
  icon = 'mdi:database-off-outline',
  iconSize = 64,
  actionLabel = '',
  onAction = null,
  className = ''
}) => {
  const { t } = useTranslation()

  return (
    <div className={`no-data-container ${className}`}>
      <div className="no-data-content">
        <Block isRender={!!icon} className="no-data-icon-wrapper">
          <Icon
            icon={icon}
            className="no-data-icon"
            width={iconSize}
            height={iconSize}
          />
        </Block>

        <h3 className="no-data-message">{t(message)}</h3>

        <Block isRender={!!description}>
          <p className="no-data-description">{t(description)}</p>
        </Block>

        <Block isRender={!!(actionLabel && onAction)} className="no-data-action">
          <button
            className="no-data-action-button"
            onClick={onAction}
          >
            {t(actionLabel)}
          </button>
        </Block>
      </div>
    </div>
  )
}

export default memo(NoData)

